<template>
  <div class="ritm-scrollbar">
    <vue-scroll :ops="ops">
      <slot></slot>
    </vue-scroll>
  </div>
</template>

<script>
export default {
  props: ["scrolling-x", "scrolling-y"],
  data() {
    return {
      ops: {
        scrollPanel: {
          scrollingX: true,
          scrollingY: true
        },
        bar: {
          keepShow: true,
          minSize: 0.1,
          hoverStyle: true
        }
      }
    };
  },
  created() {
    if (this.scrollingX === false) this.ops.scrollPanel.scrollingX = false;
    if (this.scrollingY === false) this.ops.scrollPanel.scrollingY = false;
  }
};
</script>

<style lang="scss">
.ritm-scrollbar {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 20px);
}
.tree-scrollbar {
  margin: 10px 0;
  border: 1px solid;
  border-radius: var(--border-radius);
  border-color: var(--dividers_low_contrast) !important;
  .__view {
    height: auto !important;
  }
}
.dark {
  .tree-scrollbar {
    padding-left: 4px;
    height: calc(100% - 40px);
    border: 1px solid;
    border-color: var(--dividers_low_contrast) !important;
    background-color: var(--bg_panel_secondary) !important;
  }
}
.__vuescroll {
  height: calc(100% - 10px) !important;
  .__bar-is-vertical {
    background-color: var(--accent_primary) !important;
    width: 2px !important;
    transition: width 0.1s linear, right 0.1s linear !important;
    left: auto !important;
    right: 2px !important;
  }
  .__bar-wrap-is-vertical {
    &:hover {
      .__bar-is-vertical {
        width: 6px !important;
        right: 0 !important;
      }
    }
  }
  .__bar-is-horizontal {
    background-color: var(--accent_primary) !important;
    height: 2px !important;
    transition: height 0.1s linear, bottom 0.1s linear !important;
    top: auto !important;
    bottom: 2px !important;
  }
  .__bar-wrap-is-horizontal {
    &:hover {
      .__bar-is-horizontal {
        height: 6px !important;
        bottom: 0 !important;
      }
    }
  }
  &.vBarDragging {
    .__bar-is-vertical {
      width: 6px !important;
      right: 0 !important;
    }
  }
  &.hBarDragging {
    .__bar-is-horizontal {
      height: 6px !important;
      bottom: 0 !important;
    }
  }
}
</style>
